import React from 'react';

import { Row, T8y } from 'ui';

import easySrc from 'assets/images/pictures/brands/easy.png';
import easyHistorySrc from 'assets/images/pictures/brands/easyHistory.png';

import style from './brands.module.scss';

const Brands = () => {
  return (
    <div className={style.brandsWrapper}>
      <Row
        justify="stretch"
        xsDirection="column"
        xsAlign="center"
        className={style.brandsContainer}
      >
        <div className={style.brand}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://easy.com/"
            className={style.brandLogo}
            aria-label="easy.com"
          >
            <img src={easySrc} alt="easy" />
          </a>
          <T8y variant="t1v1" color="silver">
            Visit
            <T8y
              as="a"
              variant="t1v1"
              color="primary"
              bold
              target="_blank"
              rel="noopener noreferrer"
              href="https://easy.com/"
            >
              {` easy.com `}
            </T8y>
            and learn more about the easy family of brands.
          </T8y>
        </div>
        <div className={style.brand}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://easyhistory.info/"
            className={style.brandLogo}
            aria-label="easyHistory.info"
          >
            <img src={easyHistorySrc} alt="easyHistory" />
          </a>
          <T8y variant="t1v1" color="silver">
            Visit
            <T8y
              as="a"
              variant="t1v1"
              color="primary"
              bold
              target="_blank"
              rel="noopener noreferrer"
              href="https://easyhistory.info/"
            >
              {` easyHistory.info `}
            </T8y>
            and learn about the brand history.
          </T8y>
        </div>
      </Row>
    </div>
  );
};

export default Brands;
